export default "__VITE_ASSET__CbnaMmDu__"